import { useQuery } from "@tanstack/react-query";
import api from "../../api";
import { type Product } from "../../types/api/product";

type ProductQueryKey = ["products", string];

export function useProductQuery(productId: string) {
  return useQuery<Product, Error, Product, ProductQueryKey>({
    queryKey: ["products", productId],
    queryFn: () => api.product.get(productId),
    enabled: Boolean(productId),
  });
}
